// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--2uios","linkColor":"linkColor--3QkRx","rightStyling":"rightStyling--1dPSE"};